export enum TextAreaFormat {
  TEXT = "text",
  VRM = "vrm",
}
